import { ArchivedBadge } from "@/components/ArchivedBadge";
import { EvalLimit } from "@repo/schema";
import { GripHorizontalIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLogicBuilderContext } from "./LogicBuilderContext";
import { DRAG_DATA_KEY } from "./LogicNodeList";

function DraggableLimitCard({ limit }: { limit: EvalLimit }) {
  const handleDragStart = (e: React.DragEvent) => {
    e.dataTransfer.setData(DRAG_DATA_KEY, limit.id);
    e.dataTransfer.effectAllowed = "copy";
  };

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      className="flex items-center gap-2 rounded-md border border-border bg-background px-3 py-2 text-xs text-foreground select-none cursor-grab active:cursor-grabbing hover:border-primary/50 hover:shadow-sm transition-colors"
    >
      <GripHorizontalIcon className="size-3 shrink-0 text-muted-foreground" />
      <span
        className="size-2 rounded-full shrink-0"
        style={{ backgroundColor: limit.targetLabel.color }}
      />
      <span className="font-medium truncate max-w-[140px]">{limit.name}</span>
      {limit.targetLabel.deletedAt && <ArchivedBadge />}
    </div>
  );
}

export function LimitsPanel() {
  const { t } = useTranslation(["evaluation", "common"]);
  const { availableLimits } = useLogicBuilderContext();

  if (availableLimits.length === 0) {
    return (
      <div className="flex items-center justify-center py-4 text-xs text-muted-foreground">
        {t("logicBuilder.noLimits")}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {availableLimits.map((limit) => (
        <DraggableLimitCard key={limit.id} limit={limit} />
      ))}
    </div>
  );
}
